import { render, staticRenderFns } from "./homeReview.vue?vue&type=template&id=113919a2&"
import script from "./homeReview.vue?vue&type=script&lang=js&"
export * from "./homeReview.vue?vue&type=script&lang=js&"
import style0 from "./homeReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports